import React, { useEffect } from 'react';
import {UpdateDetectedExtension} from "../../redux/actions";
import {useDispatch} from "react-redux";
import {detectExtensionPromise} from "../../utils/helperFunctions";

const ExtensionDetector = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const intervalId = setInterval(async () => {
            try {
                const result = await detectExtensionPromise();
                dispatch(UpdateDetectedExtension(result))

                if (result) {
                    clearInterval(intervalId);
                    console.log('Расширение обнаружено!');
                }
            } catch (error) {
                console.error('Ошибка проверки:', error);
            }
        }, 5000);

        // Первая проверка сразу после монтирования
        detectExtensionPromise()
            .then(result => {
                dispatch(UpdateDetectedExtension(result))
                if (result) {
                    clearInterval(intervalId);
                }
            })
            .catch(console.error);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div/>
    );
};

export default ExtensionDetector;